import { render, staticRenderFns } from "./VehicleTypeCreate.vue?vue&type=template&id=fc32612e"
import script from "./VehicleTypeCreate.vue?vue&type=script&lang=js"
export * from "./VehicleTypeCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports